import React, { useState, useEffect } from "react";
import "./css/network.css";
import { Link } from "react-router-dom";
import useIsDevice from "../../format/useIsDevice";

const Network = ({ numberPhone, combinedData }) => {
  const isDevice = useIsDevice(0, 991);
  const [open, setOpen] = useState(!isDevice);

  useEffect(() => {
    if (isDevice) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isDevice]);

  const handleToggle = () => {
    setOpen(prev => !prev);
  };

  return (
    <div className="fixed-right">
      {combinedData.map(
        (network, idx) =>
          network.icon && (
            <div
              key={idx}
              className={`item ${network.className} ${open ? "show" : "hide"}`}
            >
              <Link to={network.url} title={network.title} target="_blank">
                <img
                  src={network.icon}
                  alt={network.title}
                  className="mw-100"
                />
              </Link>
            </div>
          )
      )}

      {/*<div className={`${open ? 'border-social' : ''}`}></div>*/}

      <div className={`item phone-ring ${open ? "show" : "hide"}`}>
        <a
          href={`tel:${numberPhone.value.replace(/[^0-9+]/g, "")}`}
          title={numberPhone.title}
        >
          <img
            src="/images/icons/phone-call-1-300x300.png"
            alt={numberPhone.title}
            className="mw-100"
          />
        </a>
      </div>

      {isDevice && (
        <div className="item toggle-button show" onClick={handleToggle}>
          <i className="fas fa-plus"></i>
        </div>
      )}
    </div>
  );
};

export default Network;
